/**
 * Check if two webhook configurations are equal.
 *
 * @param a The first config.
 * @param b The second config.
 * @returns If `a` and `b` should be considered equal.
 */
export function webhookConfigsEqual(a, b) {
    if (a.tag === 'disabled') {
        return b.tag === 'disabled';
    }
    return (b.tag === 'enabled' &&
        a.templateUrl.equals(b.templateUrl) &&
        a.templateTokenId.equals(b.templateTokenId));
}
